export const summaryRows: string[] = [
  'Tomo 1 — Fundamentos de la Criminalística',
  'Tomo 2 — Investigación del Lugar de los Hechos',
  'Tomo 3 — Indicios, Evidencias y Ciencias Forenses',
  'Tomo 4 — Dactiloscopía, Huellas y Sistemas de Identificación',
  'Tomo 5 — Biología y Genética Forense',
  'Tomo 6 — Documentos, Escritura y Análisis Forense',
  'Tomo 7 — Química y Toxicología Forense',
  'Tomo 8 — Criminalística Digital y Nuevas Tecnologías',
  'Tomo 9 — Enseñanza de la Criminalística: Planificación, Actividades y Casos',
  'Bono 1 — 150 Actividades y Desafíos',
  'Bono 2 — Kit de Evaluación Completo',
  'Bono 3 — 100 Casos y Situaciones Problemáticas',
  'Bono 4 — Diccionario Docente de 200 Conceptos',
  'Bono 5 — 50 Proyectos de Investigación y Análisis',
  'Garantía de 7 días sin preguntas',
  'Acceso inmediato',
];
